import { createFileRoute } from "@tanstack/react-router";
import { OwnResident } from "@/components/app/portal/pages/own-resident";
import { ResidentVisitsPage } from "@/components/app/portal/pages/resident-visits-page";

export const Route = createFileRoute("/resident-portal/visits/")({
  head: () => ({ meta: [{ title: "Video visits | People AI" }] }),
  component: ResidentVisits,
});

function ResidentVisits() {
  return (
    <OwnResident>
      {(own) => <ResidentVisitsPage kind="resident" residentId={own.residentId} />}
    </OwnResident>
  );
}
